import { useContext } from 'react';

import { Badge } from '@repo/videa-components/src/ui/badge';
import classNames from 'classnames';

import { ExternalPatientContext } from '@/app/external/constants';

import type {
  TProcedure,
  TVisitTreatment,
} from '../../../../../react-query/useVisitSummaries';
import { ToothIcon } from '../../../../../svgs/toothIcon';
import { HoverInfo } from '../hoverInfo';
import { TreatmentStatusBadge } from '../treatmentStatusBadge';
import type { TProcedureWithAddressed } from '../utils';

interface Props {
  affectedArea: string | React.ReactNode;
  treatments?: TVisitTreatment[];
  procedures?: TProcedure[];
  recommendedProcedures?: TProcedureWithAddressed[];
  module?: 'image-viewer' | 'patient-list';
  isPerioPatient?: boolean;
}

export const QuadrantTxInfo = ({
  affectedArea,
  procedures,
  treatments,
  recommendedProcedures,
  module,
  isPerioPatient,
}: Props) => {
  const { isIframe } = useContext(ExternalPatientContext);

  if (!recommendedProcedures?.length && !treatments?.length) {
    return null;
  }

  const scheduledTreatments = treatments?.filter(
    (txInner) =>
      txInner.status === 'scheduled_today' ||
      txInner.status === 'scheduled_future',
  );
  const notScheduledTreatments = treatments?.filter(
    (txInner) => txInner.status === 'unscheduled',
  );

  const completedTreatments = treatments?.filter(
    (txInner) => txInner.status === 'completed',
  );

  return (
    <div
      className={classNames('vai-flex vai-flex-col vai-m-1', {
        'vai-gap-3': !isIframe,
        'vai-gap-2': isIframe,
      })}
    >
      <div className="vai-flex vai-items-center vai-flex-row vai-gap-2">
        <Badge className="vai-bg-zinc-100 hover:vai-bg-zinc-100 vai-text-zinc-700 vai-rounded-xl vai-py-1 vai-px-2 vai-font-inter vai-flex vai-items-center vai-gap-2">
          <ToothIcon />
          <p>{affectedArea}</p>
        </Badge>
        <TreatmentStatusBadge procedures={procedures} treatments={treatments} isPerioPatient={isPerioPatient} />
      </div>
      <HoverInfo
        module={module}
        scheduledTreatments={scheduledTreatments}
        notScheduledTreatments={notScheduledTreatments}
        completedTreatments={completedTreatments}
        aiFindingsList={[]}
        recommendedProcedures={recommendedProcedures}
      />
    </div>
  );
};
